<dx-popup
    #miscInvoiceEditorPopup
    width="70%"
    height="70%"
    [title]="popUpTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'" class="misc-invoice-editor-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div class="sub-title">
                    <strong>Invoice Details</strong>
                </div>

                <dx-form
                    #miscInvoiceEditorForm
                    width="100%"
                    height="100%"
                    [colCount]="3"
                    validationGroup="miscInvoiceEditor"
                    [labelLocation]="defaultLabelLocation"
                >
                    <dxi-item [isRequired]="true" [colSpan]="3" [colCount]="2" itemType="group">
                        <dxi-item>
                            <dxo-label text="Invoice Type"></dxo-label>
                            <div *dxTemplate>
                                <dx-select-box
                                    valueExpr="miscInvoiceTypeId"
                                    displayExpr="miscInvoiceTypeText"
                                    groupTemplate="group"
                                    [showClearButton]="true"
                                    [searchEnabled]="true"
                                    [grouped]="true"
                                    [dataSource]="miscInvoiceUngroupedData"
                                    [value]="miscInvoiceParam.invoiceTypeId"
                                    (onSelectionChanged)="onInvoiceTypeSelection($event.selectedItem)"
                                >
                                    <div *dxTemplate="let data of 'group'">
                                        <div class="custom-icon">
                                            {{ data.key }}
                                        </div>
                                    </div>
                                </dx-select-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Default Description"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box
                                    [readOnly]="true"
                                    [hint]="defaultDescription"
                                    [(value)]="defaultDescription"
                                ></dx-text-box>
                            </div>
                        </dxi-item>
                    </dxi-item>

                    <dxi-item [isRequired]="true">
                        <dxo-label text="Amount"></dxo-label>
                        <div *dxTemplate>
                            <dx-number-box
                                [readOnly]="!userCanOverrideFee"
                                [(value)]="miscInvoiceParam.amount"
                                [format]="currencyFormat"
                            ></dx-number-box>
                        </div>
                    </dxi-item>

                    <dxi-item [colSpan]="2">
                        <dxo-label text="Appended Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box
                                [hint]="defaultDescription"
                                [(value)]="miscInvoiceParam.appendedDescription"
                            ></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Sub Ledger"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="displayText"
                                valueExpr="key"
                                [readOnly]="accountLabelHasDefaultSubLedger"
                                [searchEnabled]="true"
                                [dataSource]="subLedgers"
                                [(value)]="miscInvoiceParam.subLedgerId"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="!!subCategories?.length" [colSpan]="2">
                        <dxo-label text="Sub Category"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="title"
                                valueExpr="code"
                                [searchEnabled]="true"
                                [dataSource]="subCategories"
                                [disabled]="!entityUsesSubCategory || !subCategories?.length"
                                [(value)]="miscInvoiceParam.subCategoryCode"
                            ></dx-select-box>
                        </div>
                    </dxi-item>

                    <dxi-item [isRequired]="true">
                        <dxo-label text="Transaction Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box [(value)]="miscInvoiceParam.transactionDate" type="date"></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="G/L Post Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                type="date"
                                [min]="miscInvoiceEditorData?.minPostDate"
                                [(value)]="miscInvoiceParam.postDate"
                            ></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Due Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box type="date" [(value)]="miscInvoiceParam.dueDate"></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item *ngIf="!showInvoiceDetailOnly">
                        <div *dxTemplate class="sub-title">
                            <strong>Payment Details</strong>
                        </div>
                    </dxi-item>
                    <dxi-item *ngIf="!showInvoiceDetailOnly">
                        <dxo-label text="Include Payment Details"></dxo-label>
                        <div *dxTemplate>
                            <dx-switch
                                switchedOffText="No"
                                switchedOnText="Yes"
                                [(value)]="isIncludePaymentDetail"
                                (onValueChanged)="onPaymentDetailChanged($event)"
                            ></dx-switch>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty" *ngIf="!showInvoiceDetailOnly"></dxi-item>
                    <dxi-item [isRequired]="isIncludePaymentDetail" *ngIf="!showInvoiceDetailOnly">
                        <dxo-label text="Payment Amount Received"></dxo-label>
                        <div *dxTemplate>
                            <dx-number-box
                                [readOnly]="!isIncludePaymentDetail"
                                [(value)]="miscInvoiceParam.paymentAmountReceived"
                                [format]="currencyFormat"
                            ></dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="isIncludePaymentDetail" *ngIf="!showInvoiceDetailOnly">
                        <dxo-label text="Payment Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-number-box
                                placeholder="(e.g. Check Num)"
                                [readOnly]="!isIncludePaymentDetail"
                                [(value)]="miscInvoiceParam.checkNumber"
                            ></dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty" *ngIf="!showInvoiceDetailOnly"></dxi-item>
                    <dxi-item [colSpan]="3" *ngIf="!showInvoiceDetailOnly">
                        <dxo-label text="Supporting Document"></dxo-label>
                        <div *dxTemplate class="supporting-document">
                            <dx-drop-down-button
                                text="Select Document"
                                [dropDownOptions]="{ width: 200 }"
                                [icon]="attachmentIcon"
                                [items]="attachmentOptions"
                                (onItemClick)="onAttachmentClick($event)"
                            ></dx-drop-down-button>
                            <span class="file-name" *ngIf="supportingDocument.fileName">
                                {{ supportingDocument.fileName }}
                            </span>
                            <dx-file-uploader
                                #fileUploader
                                labelText="Drop file here"
                                uploadMode="useButtons"
                                [multiple]="false"
                                [showFileList]="false"
                                [maxFileSize]="4000000"
                                [visible]="false"
                                (onValueChanged)="onAttachmentsSelect($event)"
                            ></dx-file-uploader>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="3" *ngIf="!showInvoiceDetailOnly">
                        <dxo-label text="Transaction Notes (Internal Only)"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-area
                                [height]="100"
                                [maxLength]="1000"
                                [(value)]="miscInvoiceParam.transactionNotes"
                                (onKeyUp)="onTextAreaKeyUp($event)"
                            ></dx-text-area>
                            <div class="remaining-characters">
                                <small [ngClass]="{ 'cc-text-required': remainingCharacters === 0 }">
                                    Characters remaining: {{ remainingCharacters }}
                                </small>
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="3">
                        <div *dxTemplate>
                            Note: A/R Default Bank:
                            <span *ngIf="!!miscInvoiceEditorData?.defaultBankName">
                                <strong>{{ miscInvoiceEditorData?.defaultBankName }}</strong>
                            </span>
                            <span *ngIf="!miscInvoiceEditorData?.defaultBankName">N/A</span>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="closeIcon"
                                (onClick)="onHidden()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Save"
                                useSubmitBehavior="true"
                                [icon]="saveIcon"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-property-community-documents
    #propertyCommunityDocuments
    selectionMode="single"
    [showSizeLimit]="false"
    (onAttach)="onAttachDocuments($event)"
></app-property-community-documents>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#miscInvoiceEditorPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
